import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { SOCIETY_LOCATION } from "../../../Routing/routes";
import LocationListLayer from "./Component/LocationListLayer";

const Location = () => {
    const links = [{ to: SOCIETY_LOCATION, text: 'Manage Location' }]
    return (
        <>
            <Breadcrumb replaceClass="mb-24" description='Configure Supported Countries, States and Cities' links={links} headingTitle="Manage Location" />
            <LocationListLayer />
        </>
    );
};

export default Location;
